import React from 'react';
import TableCoreComponent from './../../reusable/LightTable/TableCoreComponent';
import { PermissionContext, withPermission } from './../../context';
import { userHas, permissions } from "../../permissions";
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import utils from './../../utils/utilities';
import headerActions from './../../reusable/Header/Header.actions';
import api from '../../api/Categories.api';
import ImpendingCategoryDeletion from './Components/ImpendingCategoryDeletion';
import { ListingPageHeaderPerm as ListingPageHeader } from './../../reusable/LightTable/Components'
import {
    ModalDeleteLink,
    ModalDeleteLinkLinked,
    ModalBulkDeleteCategoriesLinked,
    ModalRemoveFinalEntity,
    ModalRemoveFinalEntityLinked
} from '../../reusable/Modal/ModalBodies';
import SeeAllEntitiesTableWrapper from './Components/SeeAllEntitiesTableWrapper';
import xhr from '../../utils/xhr';
import { CATEGORIES_PAGE_SIZE, PAGE_NAME_MANAGE_CATEGORIES } from './../../constants';
import CategoryEntitiesPillList from './Components/CategoryEntitiesPillList';
import { BoldedCell, ActionItemsCell } from './../../reusable/LightTable/Components';
import withPaginatedSelection from './../../reusable/LightTable/hoc/SelectablePaginated';
import withPagination from './../../reusable/LightTable/hoc/Paginated';
import withSort from './../../reusable/LightTable/hoc/Sortable';
import withSearch from './../../reusable/LightTable/hoc/Searchable';
import LightTable from './../../reusable/LightTable/VeryLightTable';
import { DeleteButton, ActionLink } from './../../reusable/Form/Buttons';
import { compose } from 'redux';
import {DateCell} from "../../reusable/LightTable/Components";
import reduxStore from '../../reduxStore';
import { sortBy } from 'lodash';

const Table = compose(
    withPermission,
    withPaginatedSelection,
    withSort,
    withSearch,
    withPagination
)(LightTable);

class ManageCategoriesPage extends TableCoreComponent {

    constructor(props) {
        super(props);

        const defaultLoadParams = {
            filters:    {query: ""},
            sorting:    reduxStore.getState().user.preferences.pagesTablesSort[PAGE_NAME_MANAGE_CATEGORIES],
            pagination: {pageNumber: 0, pageSize: CATEGORIES_PAGE_SIZE},
            reset:      false
        };
        this.defaultLoadParams = this.loadParams = defaultLoadParams;
        this.api = api;

        this.unassignEntity = this.unassignEntity.bind(this);
        this.handleSingleDelete = this.handleSingleDelete.bind(this);
        this.handleUnassignEntity = this.handleUnassignEntity.bind(this);
        this.handleBulkDelete = this.handleBulkDelete.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        headerActions.updateHeader('manageCategories');
    }

    /**
     * View function for items in table
     * @param item
     * @param searchTerm
     * @returns {{key, companyTitle: XML, status: string, duns: (string|string|*), categoryIDs: XML, object: *}}
     */
    formatItem = (item, searchTerm = "") => {
        const companyList = item.companiesList.map(company => {
            return {
                label: company.companyTitle,
                company: company
            }
        })
        return {
            key: item.category.id,
            name: <BoldedCell value={item.category.name} searchTerm={searchTerm} />,
            companies: <CategoryEntitiesPillList entities={companyList}
                                                 onRemoveEntity={this.handleUnassignEntity}
                                                 category={item}
                                                 handleShowMore={this.handleShowMore} />,
            lastUpdated: <DateCell timestamp={item.category.lastUpdated}/>,
            actions: <ActionItemsCell>
                <ActionLink to={"/categories/" + item.category.id}>
                    <FormattedMessage id="General_CoreFunctionality_UIText_general.edit" />
                </ActionLink>
                <ActionLink action={this.handleSingleDelete} params={item.category}>
                         <FormattedMessage id='General_CoreFunctionality_UIText_general.delete' />
                </ActionLink>
                 </ActionItemsCell>,
            object: item
        }
    };

    handleSingleDelete(category) {
        let modalProps = {
            categoryName: category.name,
            categoryId: category.id,
            primaryAction: () => {
                api.deleteCategories([category.id])
                    .then(() => {
                        this.deleteCategorySuccess(category);
                    });
            },
            secondaryAction: this.closeModal,
            isModalLoading: true
        }

        this.showCategoryDeleteModal(modalProps);
        utils.checkCategoryLinks(category.id)
            .then((response) => {
                modalProps.isModalLoading = false;
                if(response.count > 0) {
                    modalProps.totalCount = response.count;
                    modalProps.listItems = response.list;
                    this.showLinkedCategoryDeleteModal(modalProps);
                } else {
                    this.showCategoryDeleteModal(modalProps);
                }
            });
    }

    handleUnassignEntity(category, entity) {
        let modalProps = {
            categoryName: category.category.name,
            categoryId: category.category.id,
            entityName: entity.company.companyTitle,
            isModalLoading: true,
            secondaryAction: this.closeModal
        };

        if (category.companiesList.length === 1) {
            this.showOrphanedCategoryModal(modalProps);
            utils.checkCategoryLinks(category.category.id)
                .then((response) => {
                    modalProps.isModalLoading = false;
                    modalProps.primaryAction = () => {
                        this.unassignEntity(category.category, entity.company).then(() => {
                            this.deleteCategorySuccess(category.category)
                        });
                    }
                    if (response.count > 0) {
                        modalProps.totalCount = response.count;
                        modalProps.listItems = response.list;
                        this.showLinkedOrphanedCategoryModal(modalProps);
                    } else {
                        this.showOrphanedCategoryModal(modalProps);
                    }
                }).catch((e) => { this.showGenericError(e, true) });
        } else {
            this.setItemLoading(category, true);
            this.unassignEntity(category.category, entity.company).then(() => {
                api.getSingle(category.category.id).then(response => {
                    if (response.body.length === 0) {
                        this.showGenericError();
                        this.setItemLoading(category, false);
                    } else {
                        this.updateItem(response.body[0]);
                        this.setItemLoading(category, false);
                    }
                })
            }).catch((e) => { this.showGenericError(e, true) });
        }
    }

    handleShowMore(category) {
        let modalProps = {
            secondaryAction: this.closeModal,
            category:        category
        };
        this.showSeeAllModal(modalProps);
    }

    itemIdentifier = (a, b) => a.category.id === b.category.id;

    handleBulkDelete() {
        const props = {
            primaryAction: () => {
                api.deleteCategories(this.state.selectedItems.map(item => item.object.category.id))
                    .then(() => { this.bulkDeleteCategoriesSuccess() })
                    .catch((e) => { this.showGenericError(e, true) });
            },
            secondaryAction: this.closeModal
        }
        this.showBulkDeleteModal(props);
    }

    unassignEntity(category, entity) {
        return api.removeEntityFromCategory(category.id, entity.id)
            .then((response) => {
            })
            .catch((error) => {
                if(error.status === 400) {
                    this.showGenericError(error, true);
                } else {
                    xhr.handleAllErrors(error);
                }
            })
    }

    deleteCategorySuccess(category) {
        this.showSuccessPopup('Category_Manage_UIText_deleteCategory.successMessage', { categoryName: category.name });
        this.reloadTable();
        let newSelectedItems = this.state.selectedItems.filter(item => item.object.category.id !== category.id)
        this.setState({ selectedItems: newSelectedItems });
    }

    bulkDeleteCategoriesSuccess() {
        this.showSuccessPopup('Category_Manage_UIText_bulkDeleteCategory.successMessage');
        this.reloadTable();
        this.clearSelections();
    }

    // Modal show functions below, basically mapping of: function => JSX Modal component

    showCategoryDeleteModal(props) {
        this.setState({ activeModal: null }, () => {
            this.setState({ activeModal: <ModalDeleteLink {...props} /> })
        })
    }

    showLinkedCategoryDeleteModal(props) {
        this.setState({ activeModal: <ModalDeleteLinkLinked {...props} /> })
    }

    showOrphanedCategoryModal(props) {
        this.setState({ activeModal: null }, () => {
            this.setState({activeModal: <ModalRemoveFinalEntity {...props} />});
        });
    }

    showLinkedOrphanedCategoryModal(props) {
        this.setState({ activeModal: <ModalRemoveFinalEntityLinked {...props} /> });
    }

    showBulkDeleteModal(props) {
        this.setState({ activeModal: <ModalBulkDeleteCategoriesLinked {...props } /> });
    }

    showSeeAllModal(props) {
        this.setState({ activeModal: <SeeAllEntitiesTableWrapper {...props} /> });
    }

    headerItems = [
        {
            key: "name",
            label: <FormattedMessage id='Category_Create_UIText_addCategory.categoryName'/>,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_CATEGORIES
        },
        {
            key: "companies",
            label: <FormattedMessage id='Category_Manage_UIText_tableHeaderElement.entities'/>
        },
        {
            key: "lastUpdated",
            label: <FormattedMessage id={"RSS_Feed_UIText_feedListing.lastUpdated"}/>,
            sortable: true,
            persistableSort: PAGE_NAME_MANAGE_CATEGORIES
        },
        {
            key: "actions",
            label: ""
        }
    ]

    render = () =>
        <PermissionContext.Provider value={{ canEdit: userHas(permissions.categories.edit) }}>
            <div className="manage-categories listing-page standard-table">
                <ListingPageHeader location={"/create-category"}
                                   buttonMessageId="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.createNewCategory"/>

                <ImpendingCategoryDeletion/>

                <div className="selectable-table category-table">
                    <Table {...this.getTableProps()}
                           selectedItems={sortBy(this.state.selectedItems, item => item.name.props.value.toLowerCase())}
                           actions={<DeleteButton action={this.handleBulkDelete}
                                                  disabled={this.state.selectedItems.length === 0}/>}
                           fullScreen/>
                </div>
                {this.state.activeModal && this.state.activeModal}
            </div>
        </PermissionContext.Provider>
}

export default withRouter(ManageCategoriesPage);


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/ManageCategoriesPage.jsx